import React, { useEffect, useState, useRef } from 'react';

import {
  BsFillEnvelopeFill,
  BsFillPeopleFill,
  BsPersonPlusFill,
  BsGearFill,
  BsGrid3X3GapFill,
  BsChatLeftTextFill,
  BsBuilding,
  BsFillBriefcaseFill,
  BsReceipt,
  BsPersonLinesFill,
} from 'react-icons/bs';

import iconMensagem from '../assets/icon/mensagem.svg';
import iconMensagemOff from '../assets/icon/mensagemOff.svg';
import iconHistorico from '../assets/icon/historico.svg';
import iconOpcoes from '../assets/icon/opcoes.svg';
import iconSupervisor from '../assets/icon/supervisor.svg';
import iconUsuario from '../assets/icon/usuario.svg';
import iconGrafico from '../assets/icon/grafico.svg';

import logoMiniLiveChat from '../assets/logo/logoMiniLiveChat.svg';

import logo from '../assets/logo/cs-logo-white.png';
import MenuItem from './MenuItem';
import FooterMenu from './FooterMenu';
import HeaderMenu from './HeaderMenu';

import '../css/sideMenu.css';

import { useMessage } from '../hooks/message';
import { useAuth } from '../hooks/auth';

interface MyProps {
  onCollapse: (inactive: boolean) => void;
}

const SideMenu: React.FC<MyProps> = (props: MyProps): any => {
  const { clientWaiting, clientMessageService, clientsAccepted, chatUser } =
    useMessage();
  const { loadLogoEmpresaSuporte, urlLogoEmpresaSuporte } = useAuth();

  const administrador = localStorage.getItem('@LiveChat:administrador') === 'S';
  const master = localStorage.getItem('@LiveChat:master') === 'S';

  const [inactive, setInactive] = useState(true);
  const contentRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  const handleResize = (): void => {
    const contentElement = contentRef.current;
    if (contentElement) {
      const hasVerticalScroll =
        contentElement.scrollHeight > contentElement.clientHeight + 1;
      setHasScroll(hasVerticalScroll);
    }
  };

  useEffect(() => {
    handleResize(); // Dispara a verificação inicial

    window.addEventListener('resize', handleResize);
    loadLogoEmpresaSuporte();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    handleResize();
  }, [clientsAccepted, chatUser]);

  const menuItems = [
    {
      name: 'Chats Ativos',
      to: '/ChatActive',
      icon: iconMensagem,
      id: 1,
      admin: false,
      master: false,
      amountNotification: clientWaiting.length,
    },
    {
      name: 'Mensagens',
      to: '/Message',
      icon: iconMensagemOff,
      id: 2,
      admin: false,
      master: false,
      amountNotification: clientMessageService.length,
    },
    {
      name: 'Histórico de Conversa',
      to: '/ChatHistory',
      icon: iconHistorico,
      id: 3,
      admin: false,
      master: false,
      amountNotification: 0,
    },
    {
      name: 'Usuários',
      to: '/usuario',
      icon: iconUsuario,
      id: 4,
      admin: false,
      master: false,
      amountNotification: 0,
    },
    {
      name: 'Histórico de Atendimento',
      to: '/chatSupervisor',
      icon: iconSupervisor,
      id: 5,
      admin: false,
      master: false,
      amountNotification: 0,
    },
    {
      name: 'Dashboard',
      to: '/dashboard',
      icon: iconGrafico,
      id: 6,
      admin: false,
      master: false,
      amountNotification: 0,
    },
    {
      name: 'Configurações',
      to: '/configuracoes',
      icon: iconOpcoes,
      id: 7,
      admin: true,
      master: false,
      amountNotification: 0,
    },
  ];

  useEffect(() => {
    if (inactive) {
      document.querySelectorAll('.sub-menu').forEach((el) => {
        el.classList.remove('active');
      });
    }

    const { onCollapse } = props;

    onCollapse(inactive);
  }, [inactive]);

  return (
    <>
      <div className="menu-header position-absolute">
        <HeaderMenu />
      </div>

      <div className={`side-menu ${inactive ? 'inactive' : ''}`}>
        <div className="top-section">
          <div className="logo">
            <img src={urlLogoEmpresaSuporte} alt="Logo Empresa" />
          </div>
        </div>

        <div className="divider" />

        <div className="main-menu">
          <ul>
            {menuItems.map(
              (menuItem) =>
                (!menuItem.admin ||
                  (menuItem.admin && administrador && !menuItem.master) ||
                  (menuItem.master && master)) && (
                  <MenuItem
                    key={menuItem.id}
                    id={menuItem.id}
                    name={menuItem.name}
                    to={menuItem.to}
                    Icon={menuItem.icon}
                    amountNotification={menuItem.amountNotification}
                  />
                )
            )}
          </ul>
        </div>

        <div className="side-menu-footer">
          <img
            src={logoMiniLiveChat}
            alt="user"
            style={{ width: '4rem', height: '4rem' }}
          />
        </div>
      </div>
      <div
        ref={contentRef}
        className={`menu-footer ${hasScroll ? 'menu-footer-has-scroll' : ''}`}
        style={{ width: 'Calc(100vw - 5.4)' }}
      >
        <FooterMenu />
      </div>
    </>
  );
};

export default SideMenu;
